import React from 'react';

import S from 'app/features/billing/components/Billing/BackgroundImage.styled';

const BackgroundImage = () => (
  <S.BackgroundImage>
    <S.BackgroundImage.Image
      src={`${window.etp.config.assetsUrl}img/billing/billing-bg-lg.png`}
      srcSet={`${window.etp.config.assetsUrl}img/billing/billing-bg-lg@2x.png 2x`}
      alt=""
    />
  </S.BackgroundImage>
);

export default BackgroundImage;
